import { Routes } from "@angular/router";
import { ToolsComponent } from "./tools.component";
import { SeoConfig } from "../../../../services/seo.service";
import { env } from "../../../../../env";

export const toolsRoutes: Routes = [
    {
        path: "",
        component: ToolsComponent,
        children: [
            {
                path: "affordability",
                loadChildren: () =>
                    import(
                        "../../../shared/affordability-tool/affordability-tool.routes"
                    ).then((m) => m.affordabilityToolRoutes),
                data: {
                    seo: {
                        title: "Home Affordability Calculator | How Much House Can You Afford — HomeShark",
                        subtitle: "Home Affordability Calculator",
                        description:
                            "Calculate your true Georgia home-buying budget based on income, debt, and down payment — including taxes, insurance, and HOA, not just principal and interest.",
                        subject: "Personal Finance",
                        topic: "Homebuyer Affordability Calculator",
                        summary:
                            "Enter your income, debts, and savings to understand your comfortable to stretch affordability range to buy a home.  Includes state estimates for taxes and insurance.",
                        keywords: [
                            "affordability",
                            "afford",
                            "calculator",
                            "tool",
                        ],
                        url: `${env.domain}/tools/affordability`,
                        "og:title": "Homebuyer Affordability Calculator",
                        "og:description":
                            "Calculate your true Georgia home-buying budget based on income, debt, and down payment — including taxes, insurance, and HOA, not just principal and interest.",
                        "og:url": `${env.domain}/tools/affordability`,
                    } as SeoConfig,
                },
            },
            {
                path: "rent-vs-buy",
                loadChildren: () =>
                    import(
                        "../../../shared/rent-vs-buy-tool/rent-vs-buy.routes"
                    ).then((m) => m.rentVsBuyToolRoutes),
            },

            { path: "**", redirectTo: "/" },
        ],
    },
];
